'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Icon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _infoIcon = require('./infoIcon');

var _infoIcon2 = _interopRequireDefault(_infoIcon);

var _errorIcon = require('./errorIcon');

var _errorIcon2 = _interopRequireDefault(_errorIcon);

var _successIcon = require('./successIcon');

var _successIcon2 = _interopRequireDefault(_successIcon);

var _warningIcon = require('./warningIcon');

var _warningIcon2 = _interopRequireDefault(_warningIcon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var iconMap = {
  info: function info() {
    return _react2["default"].createElement(_infoIcon2["default"], null);
  },
  error: function error() {
    return _react2["default"].createElement(_errorIcon2["default"], null);
  },
  warning: function warning() {
    return _react2["default"].createElement(_warningIcon2["default"], null);
  },
  success: function success() {
    return _react2["default"].createElement(_successIcon2["default"], null);
  }
};
/* eslint-disable react/prop-types */

function VariantIcon(_ref) {
  var icon = _ref.icon;

  function getClassName() {
    return (0, _classnames2["default"])('rainbow-notification_icon-container', 'rainbow-notification_icon--' + icon);
  }

  if (iconMap[icon]) {
    return _react2["default"].createElement('div', {
      className: getClassName()
    }, iconMap[icon]());
  }

  return null;
}

function Icon(_ref2) {
  var icon = _ref2.icon;

  if (typeof icon === 'string') {
    return _react2["default"].createElement(VariantIcon, {
      icon: icon
    });
  }

  return _react2["default"].createElement('div', {
    className: 'rainbow-notification_icon-container'
  }, icon);
}

Icon.propTypes = {
  icon: _propTypes2["default"].node
};
Icon.defaultProps = {
  icon: null
};